
export default {
    auth : require('./auth.json'),
    recipient : require('./recipient.json'),
    company : require('./company.json'),
    campaign : require('./campaign.json'),
    report : require('./report.json'),
    leaderboard : require('./leaderboard.json'),
    gamification : require('./gamification.json'),
    ssoazure : require('./ssoAzure.json'),
    appcrendantials : require('./appCredentials.json'),
    userportal : require('./userportal.json'),
    enduserportal : require('./enduserportal.json'),
    setting : require('./setting.json'),
    teamproral : require('./teamproral.json'),
    schduleCalendar : require('./schduleCalendar.json')
}



// WEBPACK FOOTER //
// ./lang/en/index.js